import "./AsideSection.scss";

const AsideSection = (props) => {
  const { image, heading, description } = props;
  return (
    <div className="login-aside">
      <div className="login-aside__content">
        <div className="login-aside__content-wrapper">
          <div className="login-aside__main-img">
            <img src={image} alt="Login Art" />
          </div>
          <div className="login-aside__main-content">
            <h1 className="login-aside__heading">{heading}</h1>
            <p className="login-aside__description">{description}</p>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div className="outer-circle-banner"></div>
        <div className="inner-circle-banner"></div>
      </div>
      <footer className="login-aside__footer">
        <p className="login-aside__footer-text">
          i2c Inc. &copy; {new Date().getFullYear()} All Rights Reserved.
        </p>
      </footer>
    </div>
  );
};

export default AsideSection;
